import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { updatePlanTypesByCircuitType } from '../../order-request.functions';

import { actions } from 'react-redux-form';
import {
    //model
    wirelineUpgradeCircuitModel
    //action
    , setPrimaryPlanDetails
    , setSubscriptionDetails
    , setVendorDetails
    , setPlanOptions
    , setFormSubmitted
} from './../../../../../constants/model-reducers/external/request/wireline-request/wireline-upgrade-circuit.settings';

export const upgradeCircuitModelA = wirelineUpgradeCircuitModel;

const planDetailConst = {
    PlanId: 0
    , ComponentName: ''
    , ComponentCost: 0
    , ComponentDetails: ''
    , IsPrimary: true
}

const defaultState = () => ({
    simOptions: []
    , planOptions: []
    , subscription: {}
    , formSubmitted: false
    , vendorDetails: {
        Currency: ''
    }
    , primaryPlanDetails: { ...planDetailConst }
});

const initialState = defaultState();


export const wirelineUpgradeCircuitActions = {

    onSubscriptionSelect: (value, propsName, objects) => async (dispatch, state) => {

        const { wirelineUpgradeCircuitFormA } = state().form;

        if (value === '') {
            resetWirelineUpgradeCircuitModel(dispatch);
            resetWirelineUpgradeCircuitForm(dispatch);
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.CircuitId != wirelineUpgradeCircuitFormA.circuitId) {
                resetWirelineUpgradeCircuitForm(dispatch);
                resetWirelineUpgradeCircuitModel(dispatch);
                dispatch(actions.change('wirelineUpgradeCircuitFormA.circuitCode', value));
                dispatch(actions.change('wirelineUpgradeCircuitFormA.circuitId', obj.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });

                let vendor = await getVendorDetails(dispatch, obj);

                if (vendor) {
                    updatePlanTypesByCircuitType(dispatch, setPlanOptions, vendor.VendorDetailId, obj.CircuitTypeId);
                }

            }
        }
    }
    , onPlanSelect: (model, value) => async (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelineUpgradeCircuitFormA.planDetailsModel', wirelineUpgradeCircuitModel.planDetailsModel));
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
        updatePlanDetails(dispatch, value);

    }
    , submitRequest: () => async (dispatch, state) => {

        const { wirelineUpgradeCircuitFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { subscription } = state().wirelineUpgradeCircuitRequest;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
        }

        //---->to be refactored 
        //dispatch(actions.change('wirelineUpgradeCircuitFormA.planDetails.planComponents', wirelineUpgradeCircuitModel.planDetailsModel));
        //---->end

        var data = {
            ChangeRequestModel: {
                ...userData

                , CircuitId: subscription.CircuitId
                , VendorDetailId: subscription.VendorDetailId
                , BusinessJustification: wirelineUpgradeCircuitFormA.businessJustification
                , AdditionalInformation: wirelineUpgradeCircuitFormA.additionalInformation
                , PlanDetailsModel: wirelineUpgradeCircuitFormA.planDetailsModel
                , RequestTypeId: requestTypeId
                , NoEmail: true
            },
            NewPlanId: parseInt(wirelineUpgradeCircuitFormA.planId),
            IsAmending: false
        };

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/changePlan/submitChangePlan', data);

        if (!(res || res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
    , resetWirelineUpgradeCircuitForm: () => (dispatch) => {
        resetWirelineUpgradeCircuitForm(dispatch);
    }
    , resetWirelineUpgradeCircuitModel: () => (dispatch) => {
        resetWirelineUpgradeCircuitModel(dispatch);
    }
    , resetWirelineUpgradeCircuit: () => (dispatch) => {
        resetWirelineUpgradeCircuitForm(dispatch);
        resetWirelineUpgradeCircuitModel(dispatch);
    }

}

async function updatePlanDetails(dispatch, id) {
    var res = await httpGet('external/orderRequest/getPlanComponentByPlan/' + id);

    if (res != null && res.length > 0) {

        var primaryPlan = res.filter(x => x.IsPrimary === true);

        if (primaryPlan != null && primaryPlan.length > 0) {

            dispatch(actions.change('wirelineUpgradeCircuitFormA.planDetailsModel', primaryPlan));

            dispatch({
                type: setPrimaryPlanDetails,
                data: primaryPlan[0]
            });
        }
    }
}

async function getVendorDetails(dispatch, subscription) {

    var data = {
        VendorDetailId: subscription.VendorDetailId,
        CircuitTypeId: subscription.CircuitTypeId,
    };

    var res = await httpPost('external/orderRequest/getVendorDetails', data);

    if (res != null) {
        dispatch({ type: setVendorDetails, data: res });
    } else {
        dispatch({ type: setVendorDetails, data: { ...defaultState.vendorDetails } });
    }

    return res;
}


function resetWirelineUpgradeCircuitForm(dispatch) {
    dispatch({ type: setVendorDetails, data: { ...defaultState.vendorDetails } });
    dispatch({ type: setPlanOptions, data: [] });
    dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
    dispatch({ type: setFormSubmitted, data: false });
}

function resetWirelineUpgradeCircuitModel(dispatch) {
    dispatch(actions.reset('wirelineUpgradeCircuitFormA'));
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: { ...action.data }
            };
        case setPrimaryPlanDetails:
            return {
                ...state,
                primaryPlanDetails: action.data
            };
        case setPlanOptions:
            return {
                ...state,
                planOptions: action.data
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };

        default: return state;
    }
}